import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";

export async function barcodeService(val, cat) {
  //{{server_url}}/users/{{user}}/upc/02/817252010486
  const userId = await getLoggedInUser();
  let url = `${getApiUrl()}/users/${userId._id}/upc/${cat}/${val}`;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
  // .catch(function() {
  //   let data = {};
  //   return data;
  // });
}

export async function getPartialResult(val, cat) {
  const userId = await getLoggedInUser();
  let url = `${getApiUrl()}/users/${userId._id}/upc/${cat}/${val}/partial`;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function search(val, type, level, noUser, sType) {
  level = level || "111111";
  val = val.toLowerCase();
  let url = "";
  sType = sType ? sType : 4;
  if (noUser) {
    url = `${getApiUrl()}/lookup/typeaheadsearch/${type}/${sType}/${level}/${val}/20/1`;
  } else {
    const userId = getLoggedInUser()._id;
    url = `${getApiUrl()}/users/${userId}/typeaheadsearch/${type}/${sType}/${level}/${val}/20/1`;
  }

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(function () {
      let data = {
        show: [],
        data: [],
      };
      return data;
    });
}
export function getDetail(_id, type, noUser = false, lang = false) {
  let url = "",
    convertsize = "",
    langParam = "";
  if (lang) {
    langParam = "?lang_id=" + lang;
  }
  if (type == "csize") {
    convertsize = "?unitid=1";
    if (lang) {
      langParam = "&lang_id=" + lang;
    }
  }
  if (noUser) {
    url = `${getApiUrl()}/lookup/getitem/${_id + convertsize + langParam}`;
  } else {
    const userId = getLoggedInUser()._id;
    url =
      getApiUrl() +
      "/users/" +
      userId +
      "/getitem/" +
      _id +
      convertsize +
      langParam;
  }
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      console.log("📦 getDetail BROWSER raw response:", {
        _id: res._id,
        name: res.name,
        fullname: res.fullname,
        recipe: res.recipe,
        displayname: res.displayname,
        title: res.title,
        category: res.category
      });
      return res;
    });
}



// WEBPACK FOOTER //
// ./src/services/AutocompleteService.js